import { useEffect, useState } from "react"

import { useLazyGetPerftestResultsQuery } from "store/api/widgetsApi"

import { getDateRangeFromOption } from "utils/dateUtils"
import { HalfDoughnutSummaryWidget } from "components/widgets/HalfDoughnutSummaryWidget"
import { allDateSelectOptions } from "pages/vendor/Dashboard/constants"

const CHART_COLORS = {
  passed: "#86EFAC",
  issue: "#FCA5A5",
} as const

const dummyData = {
  passed: 11,
  issue: 11,
}

const initialState = {
  passed: 0,
  issue: 0,
}

interface WidgetTestStatusesProps {
  unsupported?: boolean
}

export const WidgetTestStatuses = ({ unsupported = false }: WidgetTestStatusesProps) => {
  const [selectedDateRange, setSelectedDateRange] = useState(() =>
    getDateRangeFromOption(String(allDateSelectOptions[0].value)),
  )
  const [triggerGetPerftestResults, { isFetching }] = useLazyGetPerftestResultsQuery()
  const [widgetData, setWidgetData] = useState(initialState)

  useEffect(() => {
    if (unsupported) return

    const fetchData = async () => {
      const res = await triggerGetPerftestResults({
        date_start: selectedDateRange[0],
        date_end: selectedDateRange[1],
      })
      if (res?.data?.data) {
        setWidgetData({
          passed: res.data.data.passed ?? 0,
          issue: res.data.data.issue ?? 0,
        })
      }
    }

    fetchData()
  }, [unsupported, selectedDateRange, triggerGetPerftestResults])

  const data = unsupported ? dummyData : widgetData

  return (
    <HalfDoughnutSummaryWidget
      dateSelectOptions={allDateSelectOptions}
      onSelectDateRange={setSelectedDateRange}
      defaultSelectedDateOption={allDateSelectOptions[0]}
      title="Test Statuses"
      mainLabel="Total tests"
      chartOptions={{ cutout: "65%" }}
      isFetching={!unsupported && isFetching}
      items={[
        { label: "Passed", color: CHART_COLORS.passed, value: data.passed },
        { label: "Issue", color: CHART_COLORS.issue, value: data.issue },
      ]}
    />
  )
}
